import React from "react";
import { DrawerTrigger } from "../ui/Drawer";
import { ArrowRight2 } from "iconsax-reactjs";
import { DocumentUploadIcon } from "asset/icons";
import markSuccess from "asset/images/marksuccess.svg";
import { cn } from "lib/utils";
import QuestionHelpIcon from "../QuestionHelpIcon";

export const formatFileUrl = (fileName) => {
  if (fileName?.startsWith('http')) {
    return fileName?.split("/")?.at(-1)?.replaceAll('%', ' ');
  }
  return fileName;
};

const FileUploader = ({
  title,
  setFileKey,
  forFinance = false,
  details,
  file,
  onClick,
  showSample = false,
  noModal,
  onChange,
  isLoading = false,
  uploadText
}) => {
  return (
    <div className="">
      <div
        className={cn(
          "flex items-center justify-between mb-2",
          forFinance ? "text-sm" : " text-sm md:text-base"
        )}
      >
        {title && <p className="z-50 w-7/12 text-left truncate md:w-full whitespace-nowrap text-secondary-70 overflow-ellipsis">
          {title || "Upload document"}{" "}
          {forFinance && details && <QuestionHelpIcon details={details} />}
        </p>}

        {!showSample && (
          <p>
            <DrawerTrigger asChild className="flex">
              <span
                onClick={() => setFileKey()}
                className="text-[#6F00FF] whitespace-nowrap font-normal flex gap-1 items-center cursor-pointer"
              >
                See sample
                <ArrowRight2 size="16" />
              </span>
            </DrawerTrigger>
          </p>
        )}
      </div>
      <label
        htmlFor={title}
        onClick={() => (noModal ? null : onClick?.())}
        className={cn(
          "p-3 border-[1.2px] cursor-pointer block border-[#EBEDF9] border-dashed rounded-lg",
          noModal ? "relative" : ""
        )}
      >
        {noModal && (
          <input
            type="file"
            accept="image/*,application/pdf"
            className="absolute w-full h-full opacity-0"
            onChange={(e) => onChange(e.target.files[0], e.target.files[0]?.name)}
          />
        )}
        {/* LEFT SECTION */}
        <div className="flex items-center gap-3">
          {file ? (
            <img src={markSuccess} alt="Uploaded" className="w-5 h-5" />
          ) : (
            <div className="bg-[#EBE4FF] grid items-center place-items-center rounded-full p-2">
              <DocumentUploadIcon />
            </div>
          )}

          <div className="flex flex-col w-full">
            {isLoading ? (
              <div className="overflow-hidden text-left">
                <p className="w-full mb-1 text-sm font-medium text-center text-main">
                  Loading...
                </p>
              </div>
            ) : file ? (
              <div className="overflow-hidden text-left">
                <p className="w-11/12 text-sm truncate text-main">
                  {formatFileUrl(file.name)}
                </p>
                {file.size && (
                  <p className="text-xs text-main-grey">
                    {(file.size / (1024 * 1024)).toFixed(1)} MB
                  </p>
                )}
              </div>
            ) : (
              <>
                <p className="text-sm text-left text-gray-10 font-[400]">
                  {uploadText || "Click to upload document"}
                </p>
                <p className="text-xs font-light text-left text-main-grey">
                  JPEG, PNG, JPG, PDF ・ 5 MB max.
                </p>
              </>
            )}
          </div>
        </div>
      </label>
    </div>
  );
};

export default FileUploader;
